export enum BatsSportAttributePositions {
    PITCHER = 'P',
    CATCHER = 'C',
    FIRST_BASE = '1B',
    SECOND_BASE = '2B',
    THIRD_BASE = '3B',
    SHORTSTOP = 'SS',
    LEFT_FIELD = 'LF',
    CENTER_FIELD = 'CF',
    RIGHT_FIELD = 'RF',
    SHORT_FIELD = 'SF',
    OUTFIELD = 'OF',
    INFIELD = 'IF',
    UTILITY = 'UT',
}
